
import IconButton from '@/components/elements/IconButton.vue'
import GlobalNav from '@/components/genenral/GlobalNav.vue'

export default {
  name: 'Header',

  props: {
    sm: {
      type: Boolean,
      default: true
    }
  },

  components: {
    GlobalNav,
    IconButton
  },

  setup() {
    const formatName = (name: string) => {
      return name.length > 8 ? name.slice(0, 8) + '…' : name
    }
    return {
      formatName
    }
  }
}
